import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import * as Helper from '../helpers/http.helper';
// import { PatchDocument } from '../models/patch.model';
import { environment } from '../../environments/environment';
import { GetVendorRegisterURL, Vendor } from '../models/vendor.model';
import { Paged } from '../models/pagination.model';
import { ApproveDeny } from '../models/approve-deny';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  updatableProperties: string[] = ['status', 'name', 'studentAmbassador'];

  path = 'Vendor';

  constructor(private http: HttpClient) {}

  getSingle(id: string): Observable<Vendor> {
    return Helper.getSingleModel(this.http, this.path, id);
  }

  getAll(
    pageNumber?: number,
    pageSize?: number,
    queryParams?: Map<string, any>
  ): Observable<any> {
    var paged = Helper.getPaged<Vendor>(
      this.http,
      this.path,
      pageNumber,
      pageSize,
      this.buildQueryParameters(queryParams)
    );

    return paged.pipe(
      map((data) => {
        return {
          countRequested: data.PageSize,
          pageIndex: data.CurrentPage,
          items: data.data,
          totalCount: data.TotalCount,
        };
      })
    );
  }

  getPaged(
    page: number,
    size: number,
    queryParameters: Map<string, any>
  ): Observable<Paged<Vendor>> {
    return Helper.getPaged<Vendor>(
      this.http,
      this.path,
      page,
      size,
      this.buildQueryParameters(queryParameters)
    );
  }

  create(body: Vendor): Observable<Vendor> {
    return Helper.createMdoel(this.http, this.path, body);
  }

  update(body: Vendor): Observable<Vendor> {
    return Helper.updateModel(
      this.http,
      this.path,
      this.updatableProperties,
      body
    );
  }

  delete(id: string): Observable<boolean> {
    return Helper.deleteModel(this.http, this.path, id);
  }

  protected buildQueryParameters(queryParameters?: Map<string, any>): string {
    if (queryParameters == null || queryParameters.size == 0) {
      return '';
    }

    let queryString = '&';

    for (let entry of queryParameters.entries()) {
      if (typeof entry[1] == 'object') {
        for (let val of Array.from(entry[1])) {
          queryString += entry[0] + '=' + val + '&';
        }
      } else {
        queryString += entry[0] + '=' + queryParameters.get(entry[0]) + '&';
      }
    }
    queryString = queryString.substring(0, queryString.length - 1);

    return queryString;
  }
  

  getVendorRegisterURL(): Observable<GetVendorRegisterURL> {
    return this.http.get<GetVendorRegisterURL>(
        `${environment.API}/api/${this.path}/registration-url`
    )
  }

  approveOrDenyVendor(approveOrDeny: ApproveDeny): Observable<any> {
    return this.http.post(
        `${environment.API}/api/${this.path}/approve-deny`,
        approveOrDeny
    )
  }
}
